document.addEventListener('DOMContentLoaded', () => {
	const collapsable = document.querySelectorAll('.collapsable')
	collapsable.forEach(group => {
		const trigger = group.querySelector('button')
		const content = group.querySelector('.collapsable-content')

		trigger?.addEventListener('click', () => {
			trigger.setAttribute(
				'aria-expanded',
				trigger.getAttribute('aria-expanded') === 'false'
			)
			content.style.setProperty('--height', `${content.scrollHeight}px`)
			content.toggleAttribute('hidden')
		})
		trigger?.addEventListener('keydown', e => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault()
				trigger.setAttribute(
					'aria-expanded',
					trigger.getAttribute('aria-expanded') === 'false'
				)
				content.style.setProperty('--height', `${content.scrollHeight}px`)
				content.toggleAttribute('hidden')
			}
		})
	})

	window.addEventListener('resize', () => {
		collapsable.forEach(group => {
			const content = group.querySelector('.collapsable-content')
			content.style.setProperty('--height', `auto`)
			content.style.setProperty('--height', `${content.scrollHeight}px`)
		})
	})
})
